(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-bf-closing"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('td-bf-code-copy')){customElements.define('td-bf-code-copy',class extends HTMLElement{connectedCallback(){if(this.copyReady)return;this.copyReady=true;this.querySelector('[data-copy]').addEventListener('click',async()=>{const button=this.querySelector('[data-copy]');const status=this.querySelector('[role="status"]');try{await navigator.clipboard.writeText(this.querySelector('[data-code]').textContent.trim());status.textContent=button.dataset.success;}catch{status.textContent=button.dataset.failure;}});}});}

  } catch(e) { console.error(e); }
})();
})();
